// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 715 ? "vendors" : chunkId) + "." + {"707":"4f9fc3464e87ab2a215e","715":"e9d695db54bcd2eced5e"}[chunkId] + ".js";
};